import { Link } from "react-router-dom";
import { works, formatViews } from "@/mocks/comics";

const stats = [
  { value: "1200+", label: "收录作品" },
  { value: "5", label: "签约作者" },
  { value: "8600+", label: "累计更新话数" },
];

export default function Hero() {
  const featured = works[0];

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800">
      {/* 装饰元素 */}
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-background-50/10 blur-2xl" />
      <div className="pointer-events-none absolute -right-16 top-10 h-80 w-80 rounded-full bg-accent-500/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 right-1/3 h-40 w-40 rounded-full bg-secondary-400/10 blur-2xl" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-16 pt-28 md:px-6 md:pb-20 md:pt-36 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50">
            <i className="ri-flashlight-line text-accent-400" aria-hidden="true" />
            最新章节 · 追更提醒 · 一站式漫画阅读
          </span>

          <h1 className="mt-6 font-heading text-3xl font-extrabold leading-tight tracking-tight text-background-50 md:text-5xl">
            漫蛙漫画网
            <span className="mt-2 block text-xl font-bold text-background-100/90 md:text-2xl">
              连载更新 · 追更提醒，最新章节不再错过
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-background-100/90 md:text-lg">
            漫蛙漫画网专注连载更新与追更提醒，收录最新章节、作品列表、作者专区与系列漫画。订阅后第一时间获知更新动态，不再错过任何一话，追更体验顺畅高效。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/works"
              className="whitespace-nowrap rounded-full bg-background-50 px-7 py-3.5 text-center text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-compass-3-line mr-1.5" aria-hidden="true" />
              浏览作品列表
            </Link>
            <a
              href="#subscribe"
              className="whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-notification-3-line mr-1.5" aria-hidden="true" />
              开启追更提醒
            </a>
          </div>

          <dl className="mt-10 flex flex-wrap gap-x-8 gap-y-4">
            {stats.map((s) => (
              <div key={s.label}>
                <dt className="order-2 text-xs text-background-100/80">{s.label}</dt>
                <dd className="font-heading text-2xl font-extrabold text-background-50">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 精选作品卡片 */}
        <Link
          to={`/works/${featured.id}`}
          className="group relative mx-auto block w-full max-w-[300px] md:max-w-none"
        >
          <div className="relative aspect-[3/4] overflow-hidden rounded-2xl ring-4 ring-background-50/20">
            <img
              src={featured.cover}
              alt={`本周推荐漫画 ${featured.title}`}
              title={`${featured.title} 最新章节`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/90 to-transparent p-5 pt-14">
              <span className="text-xs font-semibold text-accent-300">本周推荐</span>
              <h2 className="mt-1 font-heading text-xl font-extrabold text-background-50">{featured.title}</h2>
              <p className="mt-1 truncate text-xs text-background-100/85">{featured.lastChapter}</p>
              <div className="mt-3 flex items-center gap-3 text-xs text-background-100/85">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-400" aria-hidden="true" />
                  {featured.rating.toFixed(1)}
                </span>
                <span>{formatViews(featured.subscribers)} 人追更</span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}